// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAuth, signInAnonymously, signOut, User } from 'firebase/auth'
import { initializeFirestore } from 'firebase/firestore'
import { getRemoteConfig } from 'firebase/remote-config'
import { getStorage } from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_APP_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_APP_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_APP_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_APP_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_APP_FIREBASE_MEASUREMENT_ID
}

// Initialize Firebase
export const firebase = initializeApp(firebaseConfig)

// Initialize Auth
export const auth = getAuth(firebase)

/**
 * Returns the signed-in Firebase user, signing in anonymously when there is
 * none, so guest buyers get an ID token for authenticated endpoints. Waits for
 * the persisted session to be restored first, so a logged-in user is never
 * replaced by an anonymous one.
 */
export const ensureAuthUser = async (): Promise<User> => {
  await auth.authStateReady()
  if (auth.currentUser) {
    return auth.currentUser
  }
  const credential = await signInAnonymously(auth)
  return credential.user
}

/**
 * Ends the guest session opened by ensureAuthUser once the purchase is done,
 * so the rest of the app doesn't treat the guest as a logged-in user. Real
 * (non-anonymous) sessions are left untouched.
 */
export const signOutAnonymousUser = async (): Promise<void> => {
  await auth.authStateReady()
  if (auth.currentUser?.isAnonymous) {
    await signOut(auth)
  }
}

// Initialize Cloud Firestore
export const db = initializeFirestore(firebase, {
  ignoreUndefinedProperties: true
})

// Initialize Remote Config
export const remoteConfig = getRemoteConfig(firebase)
// Used until a fetch succeeds — e.g. a first visit on a flaky network, where
// without them `getValue` returns '' and whoami/trips hit a relative URL. These
// are the same services the per-environment env vars point at (custom domain
// vs. Cloud Run URL; checked on UAT and prod, 2026-10-31).
remoteConfig.defaultConfig = {
  tripAPI: import.meta.env.VITE_APP_TRIP_API_URL ?? '',
  tripBookBaseURL: import.meta.env.VITE_APP_TRIPBOOK_API_URL ?? ''
}

// Get a non-default Storage bucket
export const storage = getStorage(firebase)
